/**
 * Get Product By ID Use Case
 *
 * Business logic for retrieving a product by ID following clean architecture principles.
 * Handles product retrieval with proper validation.
 *
 * @module GetProductByIdUseCase
 */

import {ProductRepository} from '../repository/ProductRepository';
import {Product} from '../models/product.model';

export class GetProductByIdUseCase {
  constructor (private productRepository: ProductRepository) {}

  /**
   * Execute product retrieval by ID
   * @param id - Product ID to retrieve
   * @returns Promise<Product | null> - Product or null if not found
   */
  async execute (id: number): Promise<Product | null> {
    // Validate ID
    this.validateId(id);

    // Get product through repository
    const product = await this.productRepository.getProductById(id);

    return product;
  }

  /**
   * Validate product ID
   * @param id - Product ID to validate
   * @throws Error if validation fails
   */
  private validateId (id: number): void {
    if (!id || isNaN(id) || id <= 0) {
      throw new Error('معرف المنتج غير صحيح');
    }
  }
}

